const logger = {
  info(info) { console.log(info); },
  error(err) { console.error(err); }
};

export default logger;